import React from 'react';
import FormikAutocomplete from './FormikAutocomplete';

//ESTE ES GENERICO
const AutocompleteDefault = ({
  disabled,
  formikProps,
  label,
  field,
  lookup,
  fullWidth,
  myLabel,
  user,
  id,
}: AutocompleteProps) => {
  const lookupData = lookup.find((x) => x.column === field);

  if (
    !lookupData ||
    field === 'iD_Profile_Web' ||
    field === 'iD_ProfileSpac' ||
    field === 'iD_Course' ||
    field === 'iD_Profile' ||
    field === 'employee_Nr' ||
    field === 'profileToCopy'
  ) {
    return null;
  }

  let useMyLabel = '';
  if (myLabel !== '#') {
    useMyLabel = myLabel;
  } else {
    useMyLabel = label;
  }

  return (
    <FormikAutocomplete
      options={lookupData.values}
      name={field}
      displayValue={lookupData.displayValue}
      keyValue={lookupData.keyValue}
      label={useMyLabel}
      formikProps={formikProps}
      fullWidth={fullWidth}
      disabled={disabled}
      user={user}
      typeOfForm={id}
    />
  );
};

interface AutocompleteProps {
  //Revisar esto, no deben haber Anys
  disabled: boolean;
  formikProps: any;
  type: string;
  label: string;
  field: string;
  lookup: any[];
  fullWidth: boolean;
  myLabel: string;
  user: string;
  id: string;
}

export default AutocompleteDefault;
